import { defaultContent } from '../data/defaultContent';

export const useContent = (contentKey) => {
  return {
    content: defaultContent[contentKey],
    error: null,
    isLoading: false,
    refreshContent: () => {},
  };
};